import React from 'react';

import { FooterWrapper } from './style';

const Footer = ({ children }) => <FooterWrapper style={{ zIndex: 1 }}>{children}</FooterWrapper>;

export default Footer;
